export const CONTENT_LANGUAGE_HEADER = 'x-content-language';
